import React from 'react';
import PropTypes from 'prop-types';
import Textarea from '@webteam/textarea';
import { useField, useFormikContext } from 'formik';

const FormikTextarea = ({
  name,
  onBlur = () => {},
  onChange = () => {},
  disabled,
  ...restProps
}) => {
  const [formikProps, meta] = useField(name);
  const { status, isSubmitting, submitCount } = useFormikContext();
  return (
    <Textarea
      {...restProps}
      {...formikProps}
      disabled={
        isSubmitting ||
        (status && (status.disabled || status.submitted)) ||
        disabled
      }
      onBlur={e => {
        onBlur(e);
        formikProps.onBlur(e);
      }}
      onChange={e => {
        onChange(e);
        formikProps.onChange(e);
      }}
      error={(meta.touched || submitCount > 0) && meta.error}
    />
  );
};

FormikTextarea.propTypes = {
  name: PropTypes.string,
  ...Textarea.propTypes
};

export default FormikTextarea;
